import { asDate, asNumber, asObject, asRaw, asString } from './guards'
import { Media } from './media'

export class UserPoints {
  user_id: number | null
  loot_points: number | null

  constructor(data: unknown = {}) {
    const d = asRaw(data)
    this.user_id = asNumber(d.user_id)
    this.loot_points = asNumber(d.loot_points)
  }
}

/** The API's admin role (handler.ADMIN_ROLE). */
export const ADMIN_ROLE = 999

/** Port of constructors/user.js */
export class User {
  id: number | null
  username: string | null
  nickname: string | null
  password: string | null
  email: string | null
  role: number | null
  created_at: Date | null
  user_points: UserPoints | null
  profile_picture_id: number | null
  profile_picture: Media | null

  constructor(data: unknown = {}) {
    const d = asRaw(data)
    this.id = asNumber(d.id)
    this.username = asString(d.username)
    this.nickname = asString(d.nickname)
    this.password = asString(d.password)
    this.email = asString(d.email)
    this.role = asNumber(d.role)
    this.created_at = asDate(d.created_at)
    this.user_points = asObject(d.user_points) ? new UserPoints(d.user_points) : null
    this.profile_picture_id = asNumber(d.profile_picture_id)
    this.profile_picture = asObject(d.profile_picture) ? new Media(d.profile_picture) : null
  }

  /** Admins can do site-wide things, like featuring giveaways. */
  get is_admin(): boolean {
    return this.role === ADMIN_ROLE
  }

  get display_name(): string {
    return this.nickname ?? this.username ?? ''
  }

  get display_profile_picture(): Media {
    return this.profile_picture ?? new Media({ src: '/icons/logo.png' })
  }

  /** Alias kept from the original, where both names were used. */
  get display_media(): Media {
    return this.display_profile_picture
  }

  get display_loot_points(): number {
    return this.user_points?.loot_points ?? 0
  }
}
